import React, { useEffect, useState } from "react"
import { Link, NavLink } from "react-router-dom"
import { HiMenuAlt3, HiX } from "react-icons/hi"

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }

    window.addEventListener("scroll", handleScroll)

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Galerie", path: "/gallery" },
    { name: "A Propos", path: "/about" },
    { name: "Contact", path: "/contact" },
  ]

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-md shadow-md py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            className="flex flex-col leading-none"
            aria-label="Centre SpaLand Saphir Palace & Spa Hammamet Tunisia | Accueil"
          >
            <span className="text-2xl md:text-3xl font-bold tracking-wide text-[#b8955d]">
             Centre SpaLand 
            </span>

            <span className="text-xs uppercase tracking-[4px] text-gray-700">
             Vincci Saphir Palace & Spa Hammamet Tunisia ★★★★★
            </span>
            

          </Link>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <li key={link.name}>
                <NavLink
                  to={link.path}
                  className={({ isActive }) =>
                    `relative text-sm uppercase tracking-wider font-medium transition duration-300 ${
                      isActive
                        ? "text-[#b8955d]"
                        : "text-gray-800 hover:text-[#b8955d]"
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Desktop CTA */}
          <a
            href="https://wa.me/21697902051"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-flex items-center justify-center bg-[#b8955d] hover:bg-[#9f7d48] text-white text-sm font-medium px-6 py-3 rounded-full transition duration-300 shadow-md"
            aria-label="Prendre rendez-vous sur WhatsApp"
          >
            Réservez Maintenant
          </a>

          {/* Mobile Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-gray-900"
            aria-label="Toggle navigation menu"
          >
            {isOpen ? (
              <HiX className="text-3xl" />
            ) : (
              <HiMenuAlt3 className="text-3xl" />
            )}
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          isOpen
            ? "max-h-screen opacity-100"
            : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-white shadow-lg border-t border-gray-100">
          <ul className="flex flex-col px-6 py-6 space-y-5">
            {navLinks.map((link) => (
              <li key={link.name}>
                <NavLink
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) =>
                    `block text-sm uppercase tracking-wider font-medium transition duration-300 ${
                      isActive
                        ? "text-[#b8955d]"
                        : "text-gray-800 hover:text-[#b8955d]"
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              </li>
            ))}

            <li>
              <a
                href="https://wa.me/21697902051"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-full items-center justify-center bg-[#b8955d] hover:bg-[#9f7d48] text-white text-sm font-medium px-6 py-3 rounded-full transition duration-300"
                aria-label="Prendre rendez-vous sur WhatsApp"
              >
                Réservez Maintenant
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}